/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Passkey_Inactive_PartnerInputs */

const es_co2_error_passkey_inactive_partner = /** @type {(inputs: Error_Passkey_Inactive_PartnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El aliado de esta llave está inactivo.`)
};

/**

* @param {Error_Passkey_Inactive_PartnerInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_passkey_inactive_partner = /** @type {((inputs?: Error_Passkey_Inactive_PartnerInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Passkey_Inactive_PartnerInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_passkey_inactive_partner(inputs)
});